/* ═══════════════════════════════════════════════
   TruSmile — Header
   assets/trusmile-header.js
   Menú mobile + sticky con sombra + rotación de anuncios.
   ═══════════════════════════════════════════════ */
 
(function () {
  'use strict';
 
  function initHeader(root) {
    const burger = root.querySelector('[data-tsh-burger]');
    const closeBtn = root.querySelector('[data-tsh-close]');
    const overlay = root.querySelector('[data-tsh-overlay]');
    const nav = root.querySelector('[data-tsh-nav]');
 
    /* ── menú mobile ── */
    function openMenu() {
      root.classList.add('is-menu-open');
      if (overlay) overlay.hidden = false;
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      root.classList.remove('is-menu-open');
      if (overlay) overlay.hidden = true;
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (burger) burger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-menu-open')) closeMenu();
    });
    // al pasar a desktop, resetear
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && root.classList.contains('is-menu-open')) closeMenu();
    });
 
    /* ── sticky con sombra ── */
    if (nav) {
      let ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            nav.classList.toggle('is-stuck', window.scrollY > 4);
            ticking = false;
          });
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
 
    /* ── rotación de anuncios ── */
    const msgs = Array.prototype.slice.call(root.querySelectorAll('[data-tsh-msg]'));
    if (root.dataset.rotate === 'true' && msgs.length > 1) {
      let i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 4200);
    }
  }
 
  function boot() {
    document.querySelectorAll('[data-tsh]').forEach(initHeader);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();